import { Heading, Text } from '@flixbus/honeycomb-react';

import styles from './voucher-form-banner.module.scss';
import { Asterisk } from '../Asterisk';

interface VoucherFormBannerProps {
  title: string;
}

const VoucherFormBanner = ({ title }: VoucherFormBannerProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.titleWrapper}>
        <div className={styles.icon}>
          <flix-illustration name='voucher'></flix-illustration>
        </div>
        <Heading flushSpace size={1} extraClasses={styles.title}>
          {title}
        </Heading>
      </div>
      <div>
        <Text extraClasses={styles.info} small>
          <Asterisk /> Indicates mandatory fields
        </Text>
      </div>
    </div>
  );
};

export default VoucherFormBanner;
